/**
 * String utility functions.
 * Replaces the previous String.prototype mutation to prevent prototype pollution.
 */

export function capitalize(str) {
    if (!str) return '';
    return String(str).toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
}


